import { render, staticRenderFns } from "./HistoricoPlano.vue?vue&type=template&id=44399f34&scoped=true"
import script from "./HistoricoPlano.vue?vue&type=script&lang=ts"
export * from "./HistoricoPlano.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44399f34",
  null
  
)

export default component.exports